import { Component, FunctionalComponent } from 'preact'
import { extractRenderPropsChildren } from '../../../libs/renderProps'
import FilterOption from './FilterOption'
import { FilterSelectorProps } from './interfaces'
import SearchableFilterSelector from './SearchableFilterSelector'

interface State {
  data: any
  isSelectAll: boolean
}

const OverviewFilterTitle: FunctionalComponent = ({ children }) => {
  return (
    <div className='overview__filters-box-filter overview__filters-box-filter-title'>
      {' '}
      {children}{' '}
    </div>
  )
}

class SimpleFilterSelector extends Component<FilterSelectorProps, State> {
  constructor(props: FilterSelectorProps) {
    super(props)
    const { selectedFilterItems, items } = this.props
    this.state = {
      data: selectedFilterItems,
      isSelectAll: selectedFilterItems.length === items.length
    }
  }

  onFilterOptionSelection = (payload: string | string[]) => {
    this.setState({ data: payload, isSelectAll: false })
  }

  onClickSelectAll = () => {
    this.setState({ isSelectAll: !this.state.isSelectAll, data: [] })
    if (this.state.isSelectAll) {
      this.setState({ data: [...this.state.data, this.props.items.map(item => item.value)][0] })
    }
  }

  render({ name, items, isSearchable, children }: FilterSelectorProps, { data, isSelectAll }: State) {
    const selectionLabel = isSelectAll ? 'Deselect all' : 'Select all'
    const { onClickSelectAll, onFilterOptionSelection } = this

    const renderedChildren = extractRenderPropsChildren(children)({
      data,
      isApplyButtonDisabled: data.length === 0
    })
    if (isSearchable) {
      return (
        <div>
          <SearchableFilterSelector
            items={items}
            placeholder={`Search for ${name}`}
            onClickSelectAll={onClickSelectAll}
            selectionLabel={selectionLabel}
          >
            {({ items }) => {
              if (items === undefined) {
                return null
              }
              return items.map((item, index) => {
                if (item.name === 'separator') {
                  return <hr class='separator' />
                }
                if (item.name === 'title') {
                  return <OverviewFilterTitle>{item.value}</OverviewFilterTitle>
                }
                return (
                  <FilterOption
                    key={index}
                    item={item}
                    data={data}
                    onFilterOptionSelection={onFilterOptionSelection}
                  />
                )
              })
            }}
          </SearchableFilterSelector>
          {renderedChildren}
        </div>
      )
    }
    return (
      <div>
        <p class='select-all' onClick={onClickSelectAll}>{selectionLabel}</p>
        {items.map((item, index) => {
          if (item.name === 'separator') {
            return <hr class='separator' />
          }
          if (item.name === 'title') {
            return <OverviewFilterTitle>{item.value}</OverviewFilterTitle>
          }
          return (
            <div class='overview__filters-box-content' key={index}>
              <FilterOption
                item={item}
                data={data}
                onFilterOptionSelection={onFilterOptionSelection}
                isSelectAll={this.state.isSelectAll}
              />
            </div>
          )
        })}
        {renderedChildren}
      </div>
    )
  }
}

export default SimpleFilterSelector
